import React from 'react'
import { Redirect } from 'react-router-dom'
import { AccountAnalysisStatus } from '@mutual-services/account-types'
import {
  hasDeniedAccountStatus,
  hasApprovedAccountStatus,
  hasAnalysisAccountStatus,
  hasPendingCompleteDataStatus,
  hasRequiredPendenciesAccountStatus,
  hasRequiredNewCustomerAccountStatus,
  hasRequiredDocumentationAccountStatus,
  hasPreApprovedAccountStatus,
  hasPendenciesInAnalysis
} from '~/utils/analysisStatus'
import { useAuthAccount } from '~/store/auth/useAuthAccount'

export type RedirectPJAnalysisStepProps = {
  status?: AccountAnalysisStatus
}

export const RedirectPJAnalysisStep: React.FC<RedirectPJAnalysisStepProps> = (props) => {
  const { status } = props
  const { pjAnalysisStatus } = useAuthAccount()
  const currentStatus = status || pjAnalysisStatus.status

  if (hasDeniedAccountStatus(currentStatus) || hasApprovedAccountStatus(currentStatus) || hasRequiredNewCustomerAccountStatus(currentStatus) || hasAnalysisAccountStatus(currentStatus)) {
    return <Redirect to='/app/loan-request/feedback' />
  }

  if (hasPendingCompleteDataStatus(currentStatus)) {
    return <Redirect to='/app/loan-request/complete-account' />
  }

  if (hasRequiredDocumentationAccountStatus(currentStatus)) {
    return <Redirect to='/app/loan-request/documentation' />
  }

  if (hasRequiredPendenciesAccountStatus(currentStatus) || hasPendenciesInAnalysis(currentStatus)) {
    return <Redirect to='/app/loan-request/pendencies' />
  }

  if (hasPreApprovedAccountStatus(currentStatus)) {
    return <Redirect to='/app/loan-request/pre-proposal' />
  }

  return <Redirect to='/app/loan-request' />
}
